import { FileTypes } from './file-types';

export class File {
    reference: string;
    title: string;
    filename: string;
    originalFilename: string;
    dataString: string;
    url: string;
    downloadUrl: string;
    thumbnail: string;
    type: FileTypes;
    deleted: boolean = false;
    invalid: boolean;
    order?: number;
    isNew: boolean = false;
    isMoved: boolean = false;
    size: number;
    contentType: string;
    key: string;

    existingFile: boolean; //this is sent to the back to check if we need to upload the file or if it already exists
    existingFileName: string;

    extension: string;
    extensionType: string;
    public: boolean;

    // We store the uploadedBlob here when doing convertBlobToFile on the file service, 
    // because the datastring will not be available for large files (> 500_000_000))
    // This field is only present when someone just uploaded something onto the file uploader
    // It is not set by the back-end or sent to the back-end
    // It is sent to S3 if we don't have the datastring
    uploadedBlob?: Blob;

    downloading: boolean = false;

    get assumedType() : FileTypes {
        if (!this.dataString) {
            return FileTypes.UNKNOWN;
        }

        if (this.dataString.startsWith('data:image')) {
            return FileTypes.IMAGE;
        } else if (this.dataString.startsWith('data:video')) {
            return FileTypes.VIDEO;
        } else if (this.dataString.startsWith('data:audio')) {
            return FileTypes.MEDIA;
        } else {
            return FileTypes.DOCUMENT;
        }
    }
}

export class HouseShareFile extends File {}
